import React from 'react';
import { CtaButton } from '../ui/CtaButton';
export function EvaluationCta() {
  return <section className="w-full bg-brand py-20 md:py-24" data-id="element-110" data-mp="1esrx731bcd9z">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:items-center" data-id="element-111" data-mp="1ergr2wkeatfp">
        <div className="lg:col-span-7" data-id="element-112" data-mp="10ujsua1y69os">
          <h2 className="font-display text-4xl font-black uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl" data-id="element-113" data-mp="14tj5yhxu1crb">
            Antes de empezar otra rutina, entiende qué está fallando.
          </h2>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/90" data-id="element-114" data-mp="vtw0nl1zfmsz">
            Agenda tu diagnóstico gratuito y revisemos tu situación actual para darte claridad sobre tu próximo paso.
          </p>
        </div>
        <div className="flex flex-col items-start gap-4 lg:col-span-5 lg:items-end" data-id="element-115" data-mp="m4cjqkxty30r">
          <CtaButton variant="light" className="w-full sm:w-auto" data-id="element-116" data-mp="84uq9s9la1l2" />
          <p className="text-sm text-white/85 lg:text-right" data-id="element-117" data-mp="d2whj0h6577m">Toma menos de 2 minutos aplicar.</p>
        </div>
      </div>
    </section>;
}